var _react_refresh_temp_1, _react_refresh_temp_2, _react_refresh_temp_3, _react_refresh_temp_4, _react_refresh_temp_5, _react_refresh_temp_6;
var _react_refresh_temp_7;
_react_refresh_temp_7 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { createSelector } from '@reduxjs/toolkit';
import { createLocalVideoTrack, Track } from 'livekit-client';
import { store, useAppDispatch, useAppSelector, } from '../../../store';
import { updateIsActiveWebcam, updateShowVideoShareModal, updateVirtualBackground, } from '../../../store/slices/bottomIconsActivitySlice';
import ShareWebcamModal from '../modals/webcam/shareWebcam';
import WebcamMenu from './webcam-menu';
import { participantsSelector } from '../../../store/slices/participantSlice';
import { updateSelectedVideoDevice } from '../../../store/slices/roomSettingsSlice';
import VirtualBackground from '../../virtual-background/virtualBackground';
import { getWebcamResolution } from '../../../helpers/utils';
const isActiveWebcamPanelSelector = createSelector(_react_refresh_temp_1 = (state) => state.bottomIconsActivity, (bottomIconsActivity) => bottomIconsActivity.isActiveWebcam);
$RefreshReg$(_react_refresh_temp_1, "isActiveWebcamPanelSelector$createSelector");
const showVideoShareModalSelector = createSelector(_react_refresh_temp_2 = (state) => state.bottomIconsActivity, (bottomIconsActivity) => bottomIconsActivity.showVideoShareModal);
$RefreshReg$(_react_refresh_temp_2, "showVideoShareModalSelector$createSelector");
const isWebcamLockSelector = createSelector(_react_refresh_temp_3 = (state) => { var _a, _b; return (_b = (_a = state.session.currentUser) === null || _a === void 0 ? void 0 : _a.metadata) === null || _b === void 0 ? void 0 : _b.lock_settings; }, (lock_settings) => lock_settings === null || lock_settings === void 0 ? void 0 : lock_settings.lock_webcam);
$RefreshReg$(_react_refresh_temp_3, "isWebcamLockSelector$createSelector");
const virtualBackgroundSelector = createSelector(_react_refresh_temp_4 = (state) => state.bottomIconsActivity, (bottomIconsActivity) => bottomIconsActivity.virtualBackground);
$RefreshReg$(_react_refresh_temp_4, "virtualBackgroundSelector$createSelector");
const selectedVideoDeviceSelector = createSelector(_react_refresh_temp_5 = (state) => state.roomSettings, (roomSettings) => roomSettings.selectedVideoDevice);
$RefreshReg$(_react_refresh_temp_5, "selectedVideoDeviceSelector$createSelector");
const WebcamIcon = ({ currentRoom }) => {
    _react_refresh_temp_7();
    const dispatch = useAppDispatch();
    // we don't need this for small devices
    const showTooltip = store.getState().session.userDeviceType === 'desktop';
    const showVideoShareModal = useAppSelector(showVideoShareModalSelector);
    const isActiveWebcam = useAppSelector(isActiveWebcamPanelSelector);
    const isWebcamLock = useAppSelector(isWebcamLockSelector);
    const virtualBackground = useAppSelector(virtualBackgroundSelector);
    const selectedVideoDevice = useAppSelector(selectedVideoDeviceSelector);
    const { t } = useTranslation();
    const [lockWebcam, setLockWebcam] = useState(false);
    const [deviceId, setDeviceId] = useState();
    const [sourcePlayback, setSourcePlayback] = useState();
    const [virtualBgLocalTrack, setVirtualBgLocalTrack] = useState();
    const virtualBgVideoPlayer = useRef(null);
    // for change in webcam lock setting
    useEffect(() => {
        const closeMicOnLock = async () => {
            for (const [, publication,] of currentRoom === null || currentRoom === void 0 ? void 0 : currentRoom.localParticipant.videoTracks.entries()) {
                if (publication.track && publication.source === Track.Source.Camera) {
                    await currentRoom.localParticipant.unpublishTrack(publication.track, true);
                }
            }
            dispatch(updateIsActiveWebcam(false));
        };
        if (isWebcamLock) {
            setLockWebcam(true);
            const currentUser = participantsSelector.selectById(store.getState(), currentRoom.localParticipant.identity);
            if (currentUser === null || currentUser === void 0 ? void 0 : currentUser.videoTracks) {
                closeMicOnLock();
            }
        }
        else {
            setLockWebcam(false);
        }
    }, [isWebcamLock, currentRoom, dispatch]);
    // default room lock settings
    useEffect(() => {
        var _a, _b, _c, _d;
        const isLock = (_b = (_a = store.getState().session.currentRoom.metadata) === null || _a === void 0 ? void 0 : _a.default_lock_settings) === null || _b === void 0 ? void 0 : _b.lock_webcam;
        const isAdmin = (_d = (_c = store.getState().session.currentUser) === null || _c === void 0 ? void 0 : _c.metadata) === null || _d === void 0 ? void 0 : _d.is_admin;
        if (isLock && !isAdmin) {
            if (isWebcamLock !== false) {
                setLockWebcam(true);
            }
        }
    }, []);
    // we should check & close track
    useEffect(() => {
        if (!isActiveWebcam && virtualBgLocalTrack && !selectedVideoDevice) {
            virtualBgLocalTrack.getTracks().forEach((t) => t.stop());
        }
        if (!isActiveWebcam && !selectedVideoDevice && deviceId) {
            setDeviceId(undefined);
        }
    }, [selectedVideoDevice]);
    // this is required during changing webcam device
    useEffect(() => {
        if (!selectedVideoDevice || !deviceId) {
            return;
        }
        if (selectedVideoDevice === deviceId) {
            return;
        }
        const changeDevice = async (deviceId) => {
            await currentRoom.switchActiveDevice('videoinput', deviceId);
        };
        // for virtual background we'll require creating new stream
        const changeDeviceWithVB = async (deviceId) => {
            await createDeviceStream(deviceId);
        };
        if (virtualBackground.type === 'none') {
            changeDevice(selectedVideoDevice);
        }
        else {
            changeDeviceWithVB(selectedVideoDevice);
        }
        setDeviceId(selectedVideoDevice);
    }, [selectedVideoDevice]);
    // virtualBgLocalTrack only update when using virtual background
    // need to stop previous track before starting new one
    useEffect(() => {
        if (virtualBgLocalTrack && virtualBgVideoPlayer) {
            const el = virtualBgVideoPlayer.current;
            if (el) {
                el.srcObject = virtualBgLocalTrack;
            }
        }
        return () => {
            if (virtualBgLocalTrack) {
                virtualBgLocalTrack.getTracks().forEach((t) => t.stop());
            }
        };
    }, [virtualBgLocalTrack]);
    // for virtual background
    const handleVirtualBgVideoOnLoad = () => {
        var _a, _b;
        const el = virtualBgVideoPlayer.current;
        if (el) {
            setSourcePlayback({
                htmlElement: el,
                width: (_a = el.videoWidth) !== null && _a !== void 0 ? _a : 320,
                height: (_b = el.videoHeight) !== null && _b !== void 0 ? _b : 180,
            });
        }
    };
    const toggleWebcam = async () => {
        if (lockWebcam) {
            return;
        }
        if (!isActiveWebcam) {
            dispatch(updateShowVideoShareModal(!isActiveWebcam));
        }
        else if (isActiveWebcam) {
            // leave webcam
            for (const [, publication,] of currentRoom.localParticipant.videoTracks.entries()) {
                if (publication.track &&
                    publication.track.source === Track.Source.Camera) {
                    await currentRoom.localParticipant.unpublishTrack(publication.track, true);
                }
            }
            dispatch(updateIsActiveWebcam(false));
            dispatch(updateSelectedVideoDevice(''));
            dispatch(updateVirtualBackground({
                type: 'none',
            }));
        }
    };
    const createDeviceStream = async (deviceId) => {
        if (virtualBackground.type === 'none') {
            const resolution = getWebcamResolution();
            const track = await createLocalVideoTrack({
                deviceId: {
                    exact: deviceId,
                    ideal: deviceId,
                },
                resolution,
            });
            await currentRoom.localParticipant.publishTrack(track);
            dispatch(updateIsActiveWebcam(true));
        }
        else {
            const constraints = {
                video: {
                    // width: { min: 160, ideal: 320 },
                    // height: { min: 90, ideal: 180 },
                    deviceId: {
                        exact: deviceId,
                        ideal: deviceId,
                    },
                },
            };
            const mediaStream = await navigator.mediaDevices.getUserMedia(constraints);
            setVirtualBgLocalTrack(mediaStream);
        }
        return;
    };
    const onSelectedDevice = async (deviceId) => {
        setDeviceId(deviceId);
        await createDeviceStream(deviceId);
        dispatch(updateSelectedVideoDevice(deviceId));
    };
    // handle virtual background canvas
    const onCanvasRef = (canvasRef) => {
        const stream = canvasRef.current.captureStream(25);
        stream.getTracks().forEach(async (track) => {
            if (track.kind === Track.Kind.Video) {
                await currentRoom.localParticipant.publishTrack(track, {
                    source: Track.Source.Camera,
                    name: 'canvas',
                });
                dispatch(updateIsActiveWebcam(true));
            }
        });
    };
    const shouldShow = () => {
        var _a, _b;
        const session = store.getState().session;
        const room_features = (_a = session.currentRoom.metadata) === null || _a === void 0 ? void 0 : _a.room_features;
        const currentUser = session.currentUser;
        if (!(room_features === null || room_features === void 0 ? void 0 : room_features.allow_webcams)) {
            return false;
        }
        else if ((room_features === null || room_features === void 0 ? void 0 : room_features.admin_only_webcams) &&
            !((_b = currentUser === null || currentUser === void 0 ? void 0 : currentUser.metadata) === null || _b === void 0 ? void 0 : _b.is_admin)) {
            return false;
        }
        return true;
    };
    const getTooltipText = () => {
        if (!isActiveWebcam && !isWebcamLock) {
            return t('footer.icons.start-webcam');
        }
        else if (!isActiveWebcam && isWebcamLock) {
            return t('footer.icons.webcam-locked');
        }
        else if (isActiveWebcam) {
            return t('footer.icons.leave-webcam');
        }
    };
    const showButtons = () => {
        return (_jsxs("div", { className: "relative z-10", children: [_jsxs("div", { className: `camera footer-icon relative h-[35px] lg:h-[40px] w-[35px] lg:w-[40px] rounded-full bg-[#F2F2F2] dark:bg-darkSecondary2 hover:bg-[#ECF4FF] ltr:mr-3 lg:ltr:mr-6 rtl:ml-3 lg:rtl:ml-6 flex items-center justify-center cursor-pointer ${showTooltip ? 'has-tooltip' : ''}`, onClick: () => toggleWebcam(), children: [_jsx("span", { className: "tooltip !-left-3 tooltip-left", children: getTooltipText() }), !isActiveWebcam ? (_jsx("i", { className: "pnm-webcam primaryColor dark:text-darkText text-[12px] lg:text-[14px]" })) : null, lockWebcam ? (_jsx("div", { className: "arrow-down absolute -bottom-1 -right-1 w-[16px] h-[16px] rounded-full bg-white dark:bg-darkSecondary3 flex items-center justify-center", children: _jsx("i", { className: "pnm-lock primaryColor" }) })) : null, isActiveWebcam ? (_jsx("i", { className: "pnm-webcam secondaryColor text-[12px] lg:text-[14px]" })) : null] }), isActiveWebcam ? _jsx(WebcamMenu, { currentRoom: currentRoom }) : null] }));
    };
    const render = () => {
        return (_jsxs(_Fragment, { children: [showButtons(), showVideoShareModal ? (_jsx(ShareWebcamModal, { onSelectedDevice: onSelectedDevice })) : null, sourcePlayback && deviceId && virtualBackground.type !== 'none' ? (_jsx("div", { style: { display: 'none' }, children: _jsx(VirtualBackground, { sourcePlayback: sourcePlayback, id: deviceId, backgroundConfig: virtualBackground, onCanvasRef: onCanvasRef }) })) : null, virtualBgLocalTrack ? (_jsx("div", { style: { display: 'none' }, children: _jsx("video", { ref: virtualBgVideoPlayer, autoPlay: true, onLoadedData: handleVirtualBgVideoOnLoad }) })) : null] }));
    };
    return _jsx(_Fragment, { children: shouldShow() ? render() : null });
};
_react_refresh_temp_6 = WebcamIcon;
$RefreshReg$(_react_refresh_temp_6, "WebcamIcon");
_react_refresh_temp_7(WebcamIcon, "4cjnVgNwL9QaWc8/u3CmTE2/I/Q=", false, () => [useAppDispatch, useAppSelector, useAppSelector, useAppSelector, useAppSelector, useAppSelector, useTranslation]);
export default WebcamIcon;
